export function buildGameAnalysisEvaluationStorageKey(ownerId: string): string {
  return JSON.stringify(["game-analysis", "online-evaluations", ownerId]);
}

export function buildGameAnalysisViewerStorageKey(
  ownerId: string | null,
  problemSetId: string | number,
  problemId: string | number,
): string {
  return JSON.stringify([
    "game-analysis",
    "viewer",
    ownerId,
    String(problemSetId),
    String(problemId),
  ]);
}
